'use strict';

function collectArguments() {
  var args = arguments, i = args.length, arr = new Array(i);
  while (i--) {
    arr[i] = args[i];
  }
  return arr;
}

module.exports = collectArguments;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/function/internal/collectArguments.js
// module id = 637
// module chunks = 0